import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '150px',
    background: theme.palette.common.white,
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: theme.palette.shadow.cardBoxShadow,
    marginBottom: theme.spacing(1),
    display: 'flex',
    '& a': {
      textDecoration: 'none',
      height: '100%',
    },
    '&:hover': {
      boxShadow: '0px 4px 36px rgba(0, 10, 22, 0.28)',
    },
  },
  rootMobile: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    background: theme.palette.common.white,
    marginBottom: theme.spacing(1),
  },
  cardWrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    position: 'relative',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  imageContainer: {
    width: '30%',
    minHeight: '190px',
    marginTop: '-1px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: '#00234B',
      opacity: 0.75,
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      minHeight: 'unset',
    },
  },
  headlineOverlay: {
    position: 'absolute',
    top: '40%',
    left: '40%',
    transform: 'translate(-50%, -50%)',
    color: theme.palette.gold.main,
    fontSize: 'calc(1vw + 14px)',
    zIndex: 1,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'left',
    textAlign: 'left',
    paddingTop: '8px',
    paddingBottom: '8px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 'calc(1vw + 12px)',
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      top: '8px',
      left: '0px',
      transform: 'unset',
      textAlign: 'center',
    },
  },
  logoWrapper: {
    position: 'absolute',
    left: '-2.90625rem',
    top: '50%',
    transform: 'translateY(-50%)',
    [theme.breakpoints.only('xs')]: {
      left: '40%',
      top: 0,
    },
  },
  logo: {
    height: '6.25rem',
    width: '6.25rem',
    border: `1px solid ${theme.palette.grey.warm}`,
    backgroundColor: 'white',
    display: 'flex',
    borderRadius: '50%',
    objectFit: 'contain',
    padding: '4px',
    [theme.breakpoints.down('xs')]: {
      height: '4.90625rem',
      width: '4.90625rem',
    },
  },
  cardInfo: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    paddingLeft: '7rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '5rem',
    },
    [theme.breakpoints.only('xs')]: {
      paddingLeft: '0px',
      width: '100%',
    },
  },
  headlineWrapper: {
    top: theme.spacing(4),
    marginRight: '1.5rem',
    marginBottom: '8px',
    maxWidth: '75%',
    [theme.breakpoints.only('xs')]: {
      marginRight: 'unset',
      marginBottom: 'unset',
      maxWidth: '100%',
      paddingTop: '3rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '1rem',
      textAlign: 'center',
    },
  },
  headline: {
    color: theme.palette.secondary.main,
    overflow: 'hidden',
    fontSize: 'calc(1vw + 10px)',
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px',
    },
  },
  detailsWrapper: {
    width: `-webkit-calc(100% - ${'3rem'})`,
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'flex-end',
    paddingRight: theme.spacing(3),
    bottom: theme.spacing(4),
    backgroundColor: 'transparent',
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },
  cta: {
    color: theme.palette.blue.main,
    textAlign: 'right',
    minWidth: '105px',
    paddingBottom: '2px',
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
    [theme.breakpoints.only('xs')]: {
      textAlign: 'center',
      width: '100%',
    },
  },
  ctaButton: {
    borderTop: `1px solid ${theme.palette.grey.light}`,
    height: '50px',
  },
}))

export default useStyles
